import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setMenu,setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Table from '../components/Table';
import $ from 'jquery';

class EditUser extends BasePage {

    loadOnConstructor(){
	this.getUser = this.getUser.bind(this);
	this.cancelButton = this.cancelButton.bind(this);
	this.saveButton = this.saveButton.bind(this);
	this.updateUserCallback = this.updateUserCallback.bind(this);
	this.newUserCallback = this.newUserCallback.bind(this);
	this.handleChange = this.handleChange.bind(this);

	const {user_id} = this.getUrlParams();
	if(user_id !== undefined){
		this.state = {action: 'modify'};
		this.getUser(user_id);
	}else{
		this.state = {action: 'new'};
		this.getUser();
	}
    }

    getUser(userId){
	const api = this.getApi();
	api.getEditUserInterface(userId, (response) => {
		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		this.setState(prevState => {
			return {
			...prevState,
			user: response.user,
			privileges: response.privileges,
			profiles: response.profiles,
			i18n: response.i18n
		}});
	});
    }

    cancelButton(){
	this.goBack();
    }

    saveButton(){

	let failedValidators = {};
	if($('#name').val() === ''){
		failedValidators.name = this.getTrad('fillNameField');
	}

	if($('#email').val() === ''){
		failedValidators.email = this.getTrad('fillEmailField');
	}else if(!$('#email').val().match(/^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_\-.]+\.[a-zA-Z0-9]+$/)){
		failedValidators.email = this.getTrad('fillEmailValidFormat');
	}

	if(Object.keys(failedValidators).length !== 0){
		let message = [];
		for (let m in failedValidators){
			message.push(failedValidators[m]);
		}
		this.props.setModalContent({
			title: this.getTrad('fillAllMandatoryFields'),
			body: message,
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');
		return;
	}

	if(this.state.user.privileges){
		const stringPrivs = this.state.user.privileges.join();
		let modifiedUser = this.state.user;
		modifiedUser.privileges = stringPrivs;

		this.setState(prevState => {
			return {
				...prevState,
				user: modifiedUser
			}
		});
	}

	const api = this.getApi();

	if(this.state.action === 'modify'){
	    	api.updateUser(this.state.user,this.updateUserCallback);
	}else{
	    	api.newUser(this.state.user,this.newUserCallback);
	}

	let userPreviousState = this.state.user;
	userPreviousState.privileges = userPreviousState.privileges.split(',');



	this.setState(prevState => {
		return {
			...prevState,
			user: userPreviousState
		}
	});
    }

    updateUserCallback(response){
    	if(response.status !== 'OK'){
	    this.props.setModalContent({
		title: this.getTrad('messageFromServer'),
		body: [this.getTrad(response.message)],
		buttons: [
		{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
		]
	    });

	    $("#exampleModal").modal('toggle');

	}else{
	    this.props.setModalContent({
		title: this.getTrad('messageFromServer'),
		body: [this.getTrad('userModifiedSuccessfully')],
		buttons: [
		{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
		]
	    });

	    $("#exampleModal").modal('toggle');
	}

	//this.goBack();
    }

    newUserCallback(response){
	if(response.status !== 'OK'){

		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad(response.message)],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');

	}else{
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('userCreatedSuccessfully')],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');
	}
    }

    handleChange(event) {
	let userMod = this.state.user;
	if(event.target.name.match(/^privilege_/)){
		const parts = event.target.name.split('_');
		userMod.privileges = userMod.privileges.filter((v, i, a) => a.indexOf(v) === i);
		if(event.target.checked){
			userMod.privileges.push(parseInt(parts[1]));
		}else{
			userMod.privileges = userMod.privileges.filter(priv => priv !== parseInt(parts[1]));
		}
	}else if(event.target.name.match(/^profile$/)){
		userMod.profile = parseInt(event.target.value);
	}else if(event.target.name.match(/^bookings_email$/)){
		userMod[event.target.name] = event.target.checked;
	}else{
		userMod[event.target.name] = event.target.value;
	}

	this.setState(prevState => {
		return {
		...prevState,
		user: userMod
	}});
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.getTrad('userEdition')}</h3>
                <div className="row mt-4">
			<div className="col-12">
			
			{(this.state.user)?
				<form>
				  <div className="form-group">
				    <label htmlFor="name">Nombre</label>
				    <input type="text" className="form-control" id="name" name="name"
				    defaultValue={this.state.user?this.state.user.name:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="lastname">Apellidos</label>
				    <input type="text" className="form-control" id="lastname" name="lastname"
				    defaultValue={this.state.user?this.state.user.lastname:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="email">Email</label>
				    <input type="email" className="form-control" id="email" name="email"
				    defaultValue={this.state.user?this.state.user.email:''} onChange={this.handleChange}/>
				  </div>
				  <div className="form-group">
				    <label htmlFor="password">Password</label>
				    <input type="password" className="form-control" id="password" name="password"
				    defaultValue={this.state.user?this.state.user.password:''} onChange={this.handleChange}/>
				  </div>

				  {this.state.profiles?<div className="form-group">
				    <label htmlFor="profile">Perfil</label>
				    <select className="form-control" id="profile" name="profile" onChange={this.handleChange} 
					defaultValue={this.state.user?this.state.user.profile:undefined}>
					{this.state.profiles?this.state.profiles.map((profile,idx) => {
							return <option name={"profile_"+profile.profileId} key={'profile_option_'+idx}
							defaultValue={profile.profileId} value={profile.profileId}>
							{this.getTrad(profile.profileName)}
							</option>
					}):''}
				    </select>
				  </div>:''}
				  <div className="form-group">
				    <label htmlFor="bookings_email">Recibe correo de reservas</label>
				    <input type="checkbox" className="ml-3" id="bookings_email" name="bookings_email"
				    defaultChecked={this.state.user?.bookings_email===true?'checked':undefined} onChange={this.handleChange} />
				  </div>
				  {this.state.privileges?<><div className="form-group">
				  	<label data-toggle="collapse" 
				  	data-target="#privilegesTab" aria-expanded="false" aria-controls="privilegesTab" style={this.cursorPointer}>
				      		Permisos
				        </label>
				  </div>
				  <div className="collapse" id="privilegesTab">
				    <Table 
					config = {{
						items: this.state.privileges !== undefined?this.state.privileges:[],
						i18n: this.state.i18n !== undefined? this.state.i18n:[],
						checked: this.state.privileges !== undefined?this.state.privileges.map(p => {
							return this.state.user.privileges.indexOf(p.value) !== -1?p.value:''
						}):[],
						disabled: this.state.privileges !== undefined?
							this.state.privileges.map(p => {
								let profile = this.state.profiles.filter(pro => {
									return pro.profileId === this.state.user.profile
								});
								profile = profile.pop();
								return profile.attributes.indexOf(p.name) !== -1?p.value:false
							})
							:[],
						mapping: [
							{original: 'name', shown: 'Nombre', visible: true, bold: true},
							{original: 'value', shown: 'Conceder', visible: true, display:'check', 
								prefix: 'privilege_', change_callback: this.handleChange}
						]
					}}
					 />

				  </div></>:''}
				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton}>Guardar</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>
				</form>

			:<span>El usuario no existe</span>}

			</div>
                </div>

		<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        users: state.users
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setMenu(menu){
            dispatch(setMenu(menu));
        },
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUser)
